var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightsHo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_201)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.75024 20.1665H19.2502",
    stroke: "#1C452B",
    strokeWidth: 1.20839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13356 7.68237H3.66691C3.16274 7.68237 2.75024 8.09487 2.75024 8.59904V16.5007C2.75024 17.0049 3.16274 17.4174 3.66691 17.4174H5.13356C5.63773 17.4174 6.05023 17.0049 6.05023 16.5007V8.59904C6.05023 8.09487 5.63773 7.68237 5.13356 7.68237Z",
    stroke: "#1C452B",
    strokeWidth: 1.20839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7336 4.75684H10.2669C9.76272 4.75684 9.35022 5.16934 9.35022 5.6735V16.4994C9.35022 17.0035 9.76272 17.416 10.2669 17.416H11.7336C12.2377 17.416 12.6502 17.0035 12.6502 16.4994V5.6735C12.6502 5.16934 12.2377 4.75684 11.7336 4.75684Z",
    stroke: "#1C452B",
    strokeWidth: 1.20839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 1.83325H16.8669C16.3627 1.83325 15.9502 2.24575 15.9502 2.74992V16.4999C15.9502 17.0041 16.3627 17.4166 16.8669 17.4166H18.3335C18.8377 17.4166 19.2502 17.0041 19.2502 16.4999V2.74992C19.2502 2.24575 18.8377 1.83325 18.3335 1.83325Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#1C452B",
    strokeWidth: 1.20839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsHo);
export default __webpack_public_path__ + "static/media/insightsHO.40453db2ab3405be478aa55aaf2589e1.svg";
export { ForwardRef as ReactComponent };